import { render } from "./KitchenStockDashboard.vue?vue&type=template&id=0f4d20e1&scoped=true"
import script from "./KitchenStockDashboard.vue?vue&type=script&lang=js"
export * from "./KitchenStockDashboard.vue?vue&type=script&lang=js"

import "./KitchenStockDashboard.vue?vue&type=style&index=0&id=0f4d20e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4d20e1"]])

export default __exports__